export const useSecurityNotifications = () => {
  const notifications = ref([])

  const addNotification = (notification) => {
    const id = Date.now() + Math.random()
    const newNotification = {
      id,
      type: notification.type || 'info',
      title: notification.title || 'Notification',
      message: notification.message || '',
      duration: notification.duration || 5000,
      showProgress: notification.showProgress || false,
      ...notification
    }

    notifications.value.push(newNotification)


    if (newNotification.duration > 0) {
      setTimeout(() => {
        removeNotification(id)
      }, newNotification.duration)
    }

    return id
  }

  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  const clearAll = () => {
    notifications.value = []
  }

  const showRateLimitWarning = (remaining = null) => {
    return addNotification({
      type: 'rate_limit',
      title: 'Rate Limit Warning',
      message: remaining
        ? `You have ${remaining} requests remaining. Please slow down.`
        : 'You are approaching the rate limit. Please slow down.',
      duration: 8000,
      showProgress: true
    })
  }

  const showSecurityAlert = (message = 'Suspicious activity detected') => {
    return addNotification({
      type: 'security',
      title: 'Security Alert',
      message,
      duration: 10000,
      showProgress: true
    })
  }

  const showValidationError = (errors) => {
    const errorMessage = Array.isArray(errors)
      ? errors.join(', ')
      : typeof errors === 'object'
        ? Object.values(errors).flat().join(', ')
        : errors

    return addNotification({
      type: 'warning',
      title: 'Validation Error',
      message: errorMessage,
      duration: 6000,
      showProgress: true
    })
  }

  const showApiError = (error) => {
    let type = 'warning'
    let title = 'Error'
    let message = error.message || 'An error occurred'

    switch (error.code) {
      case 'RATE_LIMIT_EXCEEDED':
        type = 'rate_limit'
        title = 'Rate Limit Exceeded'
        message = 'Too many requests. Please wait a moment and try again.'
        break
      case 'SUSPICIOUS_ACTIVITY':
        type = 'security'
        title = 'Security Alert'
        message = 'Suspicious activity detected. Access temporarily restricted.'
        break
      case 'VALIDATION_ERROR':
        type = 'warning'
        title = 'Validation Error'
        if (error.data?.errors) {
          const errors = error.data.errors
          message = typeof errors === 'object'
            ? Object.values(errors).flat().join(', ')
            : errors
        }
        break
      case 'UNAUTHENTICATED':
        type = 'security'
        title = 'Session Expired'
        message = 'Your session has expired. Please log in again.'
        break
      case 'UNAUTHORIZED':
        type = 'warning'
        title = 'Access Denied'
        message = 'You do not have permission to perform this action.'
        break
    }

    return addNotification({
      type,
      title,
      message,
      duration: type === 'security' ? 10000 : 6000,
      showProgress: true
    })
  }

  const showSuccess = (message, title = 'Success') => {
    return addNotification({
      type: 'info',
      title,
      message,
      duration: 3000,
      showProgress: false
    })
  }

  const showInfo = (message, title = 'Information') => {
    return addNotification({
      type: 'info',
      title,
      message,
      duration: 5000,
      showProgress: false
    })
  }

  return {
    notifications: readonly(notifications),
    addNotification,
    removeNotification,
    clearAll,
    showRateLimitWarning,
    showSecurityAlert,
    showValidationError,
    showApiError,
    showSuccess,
    showInfo
  }
}
